import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Header />
      <Hero />
      <IndexSection />
      <MediaSection />
      <AppSection />
      <FaqSection />
      <FeaturesSection />
      <CommentsSection />
      <ContactSection />
      <RankingSection />
      <CarouselSection />
      <TopicsSection />
      <CardsSection />
      <UpdatesSection />
      <AboutSection />
      <Footer />
    </main>
  );
}